import SimpleImageSlider from "react-simple-image-slider";

import './imageSlider.css';

type Image = {
  url: string;
};

type ImageSliderProps = {
  images: Image[];
};

const ImageSlider = ({ images }: ImageSliderProps) => {
  return (
    <SimpleImageSlider
      style={{ borderRadius: 22 }}
      width={'100%'}
      height={'100%'}
      images={images}
      showBullets
      showNavs={false}
    />
  );
};

export { ImageSlider };